const megaMenuConfig = {
  durationIn: 0.2,
  durationOut: 0.15,
  easeIn: "power2.out",
  easeOut: "power2.in",
  yOffset: -10,
};

const hoverDelay = 300;
let hoverTimeout;

$(".subNav .hasSubMenu").on("mouseenter", function () {
  clearTimeout(hoverTimeout);
  const submenu = $(this).find(".subMenu");
  submenu.css("display", "flex").addClass("active");
  gsap.fromTo(
    submenu,
    { opacity: 0, y: megaMenuConfig.yOffset },
    {
      opacity: 1,
      y: 0,
      duration: megaMenuConfig.durationIn,
      ease: megaMenuConfig.easeIn,
    }
  );
});

$(".subNav .hasSubMenu").on("mouseleave", function () {
  const submenu = $(this).find(".subMenu");
  hoverTimeout = setTimeout(() => {
    gsap.to(submenu, {
      opacity: 0,
      y: megaMenuConfig.yOffset,
      duration: megaMenuConfig.durationOut,
      ease: megaMenuConfig.easeOut,
      onComplete: () => submenu.css("display", "none").removeClass("active"),
    });
  }, hoverDelay);
});

$(".subNav .subMenu").on("mouseenter", function () {
  clearTimeout(hoverTimeout);
});

$(".subNav .subMenu").on("mouseleave", function () {
  const submenu = $(this);
  hoverTimeout = setTimeout(() => {
    gsap.to(submenu, {
      opacity: 0,
      y: megaMenuConfig.yOffset,
      duration: megaMenuConfig.durationOut,
      ease: megaMenuConfig.easeOut,
      onComplete: () => submenu.css("display", "none").removeClass("active"),
    });
  }, hoverDelay);
});
